import { CMSPath } from "../config/Constant";
import common_en from "./en/en_translations.json";


export async function GetTranslationKeys(fetchLanguage) {
  let response = {};
  
  try {
    const headerConfig = {};

    // Fetch translation keys from CMS
    const langResponse = await fetch(`${CMSPath}/Connector/rest/assets?type=localisation&languageCode=${fetchLanguage}`, headerConfig);
    console.log("Success getting translation keys #######",langResponse);

    if (langResponse.ok) {
      const langKeys = await langResponse.json();
      console.log('%%%%%% from configTranslation',langKeys);
      response = configTranslationKeys(langKeys, common_en);
    } else {
      console.log("Failed to fetch translation keys, using default language keys");
      response = configTranslationKeys(response, common_en);
    }

    return response;
  } catch (err) {
    console.log("Got error while getting translation keys: " + JSON.stringify(err));
    response = configTranslationKeys(response, common_en);
    return response;
  }
}

export function configTranslationKeys(target, source) {
  for (const key of Object.keys(source)) {
    if (key in target) {
      if (typeof target[key] === "object" && typeof source[key] === "object") {
        configTranslationKeys(target[key], source[key]);
      }
    } else {
      target[key] = source[key];
    }
  }
  return target;
}
